import { ServiceLocationActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { ServiceLocationFormData } from 'src/screens/General/screens/ServiceLocations/components/ServiceLocationForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';
//import { ClaimFormData } from 'src/components/ClaimForm';
export interface GetServiceLocationsAction {
    type: typeof ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATIONS;
    payload: QueryParams;
}

export function getServiceLocations(params: QueryParams): GetServiceLocationsAction {
    return {
        type: ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATIONS,
        payload: params,
    };
}

export interface GetServiceLocationAction {
    type: typeof ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATION;
    payload: {
        id: number | string;
    };
}

export function getServiceLocation(id: number | string): GetServiceLocationAction {
    return {
        type: ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATION,
        payload: { id },
    };
}

export interface DeleteServiceLocationAction {
    type: typeof ServiceLocationActions.STAFF_DELETE_SERVICE_LOCATION;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteServiceLocation(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteServiceLocationAction {
    return {
        type: ServiceLocationActions.STAFF_DELETE_SERVICE_LOCATION,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistServiceLocationAction {
    type: typeof ServiceLocationActions.STAFF_PERSIST_SERVICE_LOCATION;
    payload: {
        data: ServiceLocationFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistServiceLocation(
    data: ServiceLocationFormData,
    callbacks: SagaPromise<any>,
): PersistServiceLocationAction {
    return {
        type: ServiceLocationActions.STAFF_PERSIST_SERVICE_LOCATION,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistServiceLocation = (data: ServiceLocationFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistServiceLocation(data, { resolve, reject }));
    });
};

/*export interface UpdateClaimAction {
    type: typeof ServiceLocationActions.STAFF_UPDATE_CLAIM;
    payload: {
        data: ClaimFormData;
        callbacks: SagaPromise<any>;
    };
}

export function updateClaim(data: ClaimFormData, callbacks: SagaPromise<any>): UpdateClaimAction {
    return {
        type: ServiceLocationActions.STAFF_UPDATE_CLAIM,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncUpdateClaim = (data: ClaimFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateClaim(data, { resolve, reject }));
    });
};*/

export type Actions =
    | GetServiceLocationsAction
    | GetServiceLocationAction
    | DeleteServiceLocationAction
    | PersistServiceLocationAction;
